module.exports = __webpack_public_path__ + "assets/retina_EquidistantParallelDetailed.70b415047c00f064c377a98df7b6388d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_EquidistantParallelDetailed.png
// module id = 661
// module chunks = 0